import { useState } from 'react';
import { menuTabs } from '@/mocks/homeData';

export default function Menu() {
  const [active, setActive] = useState(menuTabs[0].id);
  const current = menuTabs.find((tab) => tab.id === active) ?? menuTabs[0];

  return (
    <section id="menu" className="py-20 md:py-28 bg-background-50">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-12 bg-primary-500/50"></span>
            <span className="text-primary-500">◆</span>
            <span className="h-px w-12 bg-primary-500/50"></span>
          </div>
          <span className="text-xs uppercase tracking-[0.3em] text-primary-500/90">Our Offerings</span>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-50 mt-4">
            Our Menu
          </h2>
          <div className="flex items-center justify-center gap-3 my-6">
            <span className="h-px w-12 bg-primary-500/50"></span>
            <span className="text-primary-500">✦</span>
            <span className="h-px w-12 bg-primary-500/50"></span>
          </div>
          <p className="text-foreground-200/70 text-sm md:text-base max-w-xl mx-auto">
            Authentic Caribbean cuisine crafted with bold flavors and fresh ingredients.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {menuTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className={`whitespace-nowrap px-5 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer ${
                active === tab.id
                  ? 'bg-primary-500 text-background-950'
                  : 'bg-background-100 text-foreground-200 border border-background-200/60 hover:text-primary-500'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-10">
          {current.note && (
            <p className="mb-6 text-center text-xs md:text-sm text-primary-500/90 italic">
              {current.note}
            </p>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-7">
            {current.items.map((item) => (
              <div key={item.name} className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <h4 className="font-heading text-lg md:text-xl font-semibold text-foreground-50">
                    {item.name}
                  </h4>
                  {item.desc && (
                    <p className="mt-1 text-xs md:text-sm text-foreground-200/60">{item.desc}</p>
                  )}
                </div>
                {item.price && (
                  <>
                    <span className="mt-1 text-sm font-semibold text-primary-500 whitespace-nowrap">
                      {item.price}
                    </span>
                    <span className="mt-2 hidden md:block flex-1 border-b border-dotted border-background-300/50 max-w-[120px]"></span>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}